import { create } from 'zustand';
export interface Disaster {
  id: string;
  name: string;
  startDateTime: string;
  stopDateTime: string | null;
  lastUpdateDate: string;
}

export interface WaDisasterStore {
  selectedDisaster: Disaster | null | undefined;
  setSelectedDisaster: (selectedDisaster: Disaster | null | undefined) => void;
}

export const useWaDisasterStore = create<WaDisasterStore>()((set) => ({
  selectedDisaster: undefined,
  setSelectedDisaster: (selectedDisaster) => set({ selectedDisaster }),
}));
